import { makeReactHotToast } from './makeReactHotToast.tsx';
import { MakeToast } from './types.ts';

export const useToaster = () => {
  const makeToast: MakeToast = makeReactHotToast;

  return makeToast;
};
